import { formatFxRate, type FxRate } from '@abastece/shared';
import { useT } from '../i18n/index.js';
import type { MonedaDeLosLibros } from '../lib/libros.js';

/**
 * Córdobas or dollars, as the drawer's C$ and US$ are picked, for every figure on a page of the
 * books: «Contabilidad» (the owner, 2026-10-12: «a radio button to change the values from cordobas
 * to dollars») and «Análisis» (2026-10-13: «the analytics page also needs a cordoba/dollar toggle
 * similar to the accounting page»). Beside the periods, and under them on a phone. «Por comprar»
 * (2026-10-16) has it beside its lists' tabs, and under them where a phone has no room.
 */
export function ElegirMoneda({ moneda, onElegir }: { moneda: MonedaDeLosLibros; onElegir: (m: MonedaDeLosLibros) => void }) {
  const t = useT();
  return (
    <div role="radiogroup" aria-label={t('conta.moneda')} className="ml-auto flex gap-1 rounded-xl bg-slate-800 p-1" data-elegir-moneda>
      {(['NIO', 'USD'] as const).map((m) => (
        <button
          key={m}
          type="button"
          role="radio"
          aria-checked={moneda === m}
          onClick={() => onElegir(m)}
          data-sin-icono="pestana"
          data-moneda={m}
          className={`min-h-9 rounded-lg px-4 text-sm font-medium transition ${
            moneda === m ? 'bg-marca-600 text-white' : 'text-slate-400 hover:bg-white/5 hover:text-slate-200'
          }`}
        >
          {m === 'NIO' ? 'C$' : 'US$'}
        </button>
      ))}
    </div>
  );
}

/**
 * The switch in a row of its own over a page's figures, and in dollars what they are at: «Control»
 * and «Gastos» (2026-10-13), which have no row of periods for it to sit at the end of.
 */
export function FilaMoneda({
  moneda,
  onElegir,
  tasa,
  className = 'mb-3',
}: {
  moneda: MonedaDeLosLibros;
  onElegir: (m: MonedaDeLosLibros) => void;
  tasa: FxRate;
  className?: string;
}) {
  const t = useT();
  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`} data-fila-moneda>
      {moneda === 'USD' && (
        <p className="min-w-0 flex-1 basis-48 text-xs text-slate-500" data-en-dolares>
          {t('conta.enDolares', { tasa: formatFxRate(tasa) })}
        </p>
      )}
      <ElegirMoneda moneda={moneda} onElegir={onElegir} />
    </div>
  );
}
